import PropTypes from "prop-types";
import React from "react";

const EmailDomainErrors = ({ errors }) => {
  const messages = Object.values(errors).flat().filter(Boolean).map(String);
  if (messages.length === 0) {
    return null;
  }
  return (
    <div className="text-danger my-2" role="alert">
      {messages.join(" ")}
    </div>
  );
};
EmailDomainErrors.propTypes = { errors: PropTypes.object.isRequired };

export default EmailDomainErrors;
